<script>
import { CallStatus } from '@/views/cati/enum'

export default {
  name: 'ErrorExit',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      options: [
        { label: '拒访', value: CallStatus.Refusal },
        { label: '不是本人', value: CallStatus.NotMyself },
        { label: '电话故障有杂音', value: CallStatus.Noise },
      ],
      radioValue: CallStatus.Noise
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onCancel() {
      let val = this.options.find(item => item.value === this.radioValue).label
      let status = this.radioValue
      this.$emit('cancel', status, val)
    },
    onSave() {
      let val = this.options.find(item => item.value === this.radioValue).label
      let status = this.radioValue
      this.$emit('confirm', status, val)
    },
  },
  mounted() {
    this.visible = true
  }
}
</script>

<template>
  <el-dialog
      :visible="visible"
      title="异常中断"
      @close="onClose"
      custom-class="theme-dialog split-line-footer-dialog"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
  >
    <div class="leading-22">检测到您的上一通电话异常中断，是否继续执行？</div>
    <div class="mt-4">
      <ul>
        <li>样本号码：{{ data.current.phoneNumber }}</li>
<!--        <li>中断时间：2023-09-09 19:00:09</li>-->
        <li class="mt-2">中断原因：刷新页面或关闭页面</li>
      </ul>
    </div>
    <template #footer>
      <div class="text-right">
        <el-button type="primary" @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSave">继续执行</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>